import React, {useState} from 'react';
import Modal from 'react-modal';

const OrganisationPrivacyModal = ({isOpen, onRequestClose, onConfirm}) => {

  const closeOrganisationPrivacyModal = () => {
    onRequestClose();
};

const handleConfirm = () => {
    // Call the onConfirm function passed as a prop
    onConfirm();
    // Close the modal
    closeOrganisationPrivacyModal();
};


return (
 
      <div className="modal-content">
        <div className="modal-header border-bottom">
          <h5 className="modal-title font-weight-600 font-26 px-4 py-3 mt-2 mb-0">Your Organisation’s Privacy Matters – Why We Collect This Information</h5>
        </div>
        <div className="modal-body py-3 p-4">
          <p className='small'>
            We collect your POSH compliance documents to help you stay audit-ready, maintain accurate records, and keep all your compliance documents organised in one secure place, accessible only to authorised admins of your organisation. These documents are used solely for verification and record-keeping purposes and are never shared with third parties unless legally required or approved by you. We retain these documents during the contract period and for up to one year after the contract expires, after which they are securely deleted. You can update or remove your documents anytime during the contract. We believe in complete transparency—your documents belong to you, and we are here only to help you manage them with ease and confidence.</p>
        </div>
        <div className="modal-footer border-top px-3 py-3">
          <button type="button" className="btn btn-primary py-2 px-4 mx-auto btn-md" onClick={handleConfirm}>Ok</button>
        </div>
      </div>
   
  );

}

export default OrganisationPrivacyModal;
